// @vendors
const { createActions } = require("redux-actions");
// @actions
const { validateAndExecute } = require('actions/signaturePattern');
const { updateConsents } = require('actions/gdprConsents');
// @helpers
const { APIPost, APIPatch } = require('utilities/APIRequestHelper');
const { getTaeInfo } = require('../loansUtilities/loansHelper');
// @constants
const dossierStatus = require('../loansConstants/dossierStatus');

const simpleActions = createActions(
    "ARES_DOSSIER_STATUS",
    "ARES_DOSSIER_STATUS_ERROR",
    "ARES_DOSSIER_STATUS_SUCCESS",
    "ARES_DOSSIER_LOAN_COMPLETE"
);

const completeAresDossier = () => (dispatch, getState) => {
    let response = getState().aresDossier.get("dossier");
    response = response.set('status', dossierStatus.LOAN_COMPLETE);

    dispatch(simpleActions.aresDossierLoanComplete({ response }))
}

const retrieveAresDossier = () => (dispatch) => {
    dispatch(simpleActions.aresDossierStatus());
    return APIPost({ dispatch, endpoint: "aresRetrieveDossier" })
        .then((response) => 
            dispatch(simpleActions.aresDossierStatusSuccess({ response }))
        )
        .catch((response) => {
            if (!!response.error) {
                if (response.error.status === 422) {
                    dispatch(simpleActions.aresDossierStatusSuccess({ response: null, }));
                } else {
                    dispatch(simpleActions.aresDossierStatusError({ error: response.error, }));
                }
            } else {
                throw response;
            }
        });
};

const cancelAresDossier = (dossierId, finalCallback) => (dispatch, getState) => {
        dispatch(simpleActions.aresDossierStatus());

        const params = {
            dossierId: dossierId || getState().aresDossier.get("dossier").get("id"),
        };
        return APIPost({ dispatch, endpoint: "aresCancelDossier", params })
            .then(() => dispatch(retrieveAresDossier()))
            .catch((response) => {
                if (!!response.error) {
                    dispatch(simpleActions.aresDossierStatusError({ error: response.error, }));
                }
                throw response;
            })
            .finally(() => {
                if (finalCallback) {
                    finalCallback();
                }
            });
    };

const cancelAresCounterOfferDossier = (dossierId, finalCallback) => (dispatch, getState) => {
    dispatch(simpleActions.aresDossierStatus());

    const params = {
        dossierId:  dossierId || getState().aresDossier.get("dossier").get("id"),
        query: { accepted: false },
    };
    return APIPost({ dispatch, endpoint: "aresCancelCounterOfferDossier", params, })
        .then(() => dispatch(retrieveAresDossier()))
        .catch((response) => {
            if (!!response.error) {
                dispatch(simpleActions.aresDossierStatusError({ error: response.error, }));
            }
            throw response;
        })
        .finally(() => {
            if (finalCallback) {
                finalCallback();
            }
        });
};

const cancelDossier = () => (dispatch, getState) => {
    const dossier = getState().aresDossier.get("dossier");
    if (dossier) {
        if (dossier.get('status') === dossierStatus.M2_COUNTEROFFER) {
            return dispatch(cancelAresCounterOfferDossier());
        } else {
            return dispatch(cancelAresDossier());
        }
    }
}

const setAresConsentsDossier = (consents, cirbeAcceptedText, vedaconAcceptedText, dossierId = null) => (dispatch, getState) => {
    dispatch(simpleActions.aresDossierStatus());

    const globalParams = {
        dossierId: dossierId || getState().aresDossier.get("dossier").get("id"),
        query: { consents },
    };

    const consentsParams = {
        ...globalParams,
        query: { ...globalParams.query, cirbeAcceptedText, vedaconAcceptedText }
    };

    const documentationParams = {
        ...globalParams,
        query: { ...globalParams.query, gender: getState().profile.get("sexo") }
    };

    const promises = [
        APIPost({
            dispatch,
            params: consentsParams,
            endpoint: "aresSetConsentsDossier"
        }),
        APIPost({
            dispatch,
            params: documentationParams,
            endpoint: "aresSetDocumentationDossier"
        })
    ];

    return Promise.all(promises)
        .then(() => dispatch(retrieveAresDossier()))
        .catch((response) => {
            if (!!response.error) {
                dispatch(
                    simpleActions.aresDossierStatusError({
                        error: response.error,
                    })
                );
            }
        });
};

const setAresContractingInfo = (proposalData, paymentDayType, selectedAccount) => (dispatch, getState) => {
    dispatch(simpleActions.aresDossierStatus());

    const params = {
        dossierId: getState().aresDossier.get('dossier').get('id'),
        query: {
            paymentDayType,
            paymentDay: new Date(Date.now()).getDate(),
            loanAccount: selectedAccount.get('iban'),
            accountData: {
                accountId: selectedAccount.get('accountId'),
                alias: selectedAccount.get('alias'),
                iban: selectedAccount.get('iban'),
                balance: selectedAccount.get('balance'),
            },
            proposalData,
        }
    };
    return APIPost({ dispatch, endpoint: 'aresContractingInfo', params })
        .then(() => dispatch(retrieveAresDossier()))
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.aresDossierStatusError({ error: response.error }))
            }
        });
}

const registerProposal = (contractingData, paymentDayType, selectedAccount) => (dispatch) => {
    dispatch(simpleActions.aresDossierStatus());

    const taeInfo = getTaeInfo(contractingData, paymentDayType);
    const params = {
        query: {
            standard: {
                standardCode: taeInfo && taeInfo.get('productStandard'),
                productSubtype: {
                    productSubtype: contractingData.get('productSubtype').toString(),
                    productType: {
                        productType: contractingData.get('productType'),
                    }
                },
            },
            amount: {
                currency: contractingData.get('currency'),
                amount: parseInt(contractingData.get('amount'), 10),
            },
            deadline: {
                unitsNumber: parseInt(contractingData.get('term'), 10),
            }
        }
    };

    return APIPost({ dispatch, endpoint: 'aresRegisterProposal', params })
        .then((proposalData) => dispatch(setAresContractingInfo(proposalData, paymentDayType, selectedAccount)))
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.aresDossierStatusError({ error: response.error }))
            }
        });
};

const updateState = (status) => (dispatch, getState) => {
    dispatch(simpleActions.aresDossierStatus());

    const params = {
        dossierId: getState().aresDossier.get('dossier').get('id'),
        query: { status }
    };
    return APIPatch({ dispatch, endpoint: 'aresUpdateState', params })
        .then(() => dispatch(completeAresDossier()))
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.aresDossierStatusError({ error: response.error }))
            }
        });

}

const updateCounterOfferState = (accepted) => (dispatch, getState) => {
    dispatch(simpleActions.aresDossierStatus());

    const params = {
        dossierId: getState().aresDossier.get('dossier').get('id'),
        query: { accepted },
    };
    return APIPost({ dispatch, endpoint: 'aresUpdateCounterOfferState', params })
        .then(() => dispatch(completeAresDossier()))
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.aresDossierStatusError({ error: response.error }))
            }
        });

}

const aresFinalization = (query) => (dispatch, getState) => {
    dispatch(simpleActions.aresDossierStatus());
    const currentStatus = getState().aresDossier.get('dossier').get('status');

    const params = { query };
    return APIPost({ dispatch, endpoint: 'aresFinalization', params })
        .then(() => {
            if (currentStatus === dossierStatus.APPROVED) dispatch(updateState(dossierStatus.LOAN_COMPLETE));
            else if (currentStatus === dossierStatus.M2_COUNTEROFFER) dispatch(updateCounterOfferState(true));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.aresDossierStatusError({ error: response.error }))
            }
        });
}

const validateSignature = (func) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        dispatch(updateConsents(dataToken))
            .then(() => func())
            .catch(() => func());
    };

    validateAndExecute(dispatch, getState, callback);
}

module.exports = {
    retrieveAresDossier,
    cancelDossier,
    setAresConsentsDossier,
    registerProposal,
    aresFinalization,
    validateSignature,
    simpleActions
};
